module.exports = __webpack_public_path__ + "img/9077f07.png";